var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsShowIndeterminateIcon = function SvgDsShowIndeterminateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5F677E",
    fillRule: "evenodd",
    d: "m.862 7.863.471.472c-.471-.472-.47-.473-.47-.473l.003-.004.009-.008.03-.028q.036-.036.104-.097c.09-.08.22-.194.387-.328a11 11 0 0 1 1.44-.975C4.07 5.717 5.85 5.002 8 5.002s3.93.715 5.164 1.42c.618.354 1.105.708 1.44.975a9 9 0 0 1 .491.425l.03.028.008.008.003.003v.001l.002.001a.667.667 0 0 1-.942.944l-.001-.001-.002-.002-.017-.017-.079-.072a7 7 0 0 0-.326-.277 10 10 0 0 0-1.269-.858 9.6 9.6 0 0 0-2.497-1.003 2.667 2.667 0 1 1-4.01 0A9.6 9.6 0 0 0 3.497 7.58a10 10 0 0 0-1.268.858 7 7 0 0 0-.405.35l-.017.016-.003.003a.666.666 0 1 1-.942-.944m5.805.472a1.333 1.333 0 1 1 2.666 0 1.333 1.333 0 0 1-2.666 0",
    clipRule: "evenodd"
  })));
};
export default SvgDsShowIndeterminateIcon;